module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "libioss gv-color-scheme"
  }, [_vm._c('div', {
    staticClass: "libioss-title gv-color-scheme"
  }, [_vm._v("\n    Libioss - Distribuzione specie animali\n    "), _vm._v(" "), _vm._c('button', {
    staticClass: "gv-color-scheme libioss-download-button el-icon-download",
    attrs: {
      "id": "libioss-download-button",
      "title": "Download Dati",
      "size": "mini"
    },
    on: {
      "click": _vm.download
    }
  }), _vm._v(" "), _vm._c('button', {
    staticClass: "gv-color-scheme libioss-download-button el-icon-files",
    attrs: {
      "id": "libioss-download-button",
      "title": "Gestione Livelli",
      "size": "mini"
    },
    on: {
      "click": _vm.layerMngr
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "libioss-wrapper gv-color-scheme",
    attrs: {
      "id": "libioss-wrapper"
    }
  }, [_vm._c('div', {
    staticClass: "combo"
  }, [_vm._c('el-select', {
    attrs: {
      "placeholder": "Seleziona Gruppo",
      "size": "mini",
      "filterable": ""
    },
    on: {
      "change": _vm.onChangeGruppo
    },
    model: {
      value: (_vm.gruppo),
      callback: function($$v) {
        _vm.gruppo = $$v
      },
      expression: "gruppo"
    }
  }, _vm._l((_vm.gruppi), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSpecie),
      expression: "showSpecie"
    }],
    staticClass: "combo"
  }, [_vm._c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Seleziona Specie",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeSpecie
    },
    model: {
      value: (_vm.specie),
      callback: function($$v) {
        _vm.specie = $$v
      },
      expression: "specie"
    }
  }, _vm._l((_vm.listaSpecie), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "disabled": item.disabled,
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLayerMngr),
      expression: "showLayerMngr"
    }]
  }, [_vm._c('div', {
    staticClass: "layer-mngr"
  }, [_vm._c('div', {
    staticClass: "combo"
  }, [_vm._v("GESTIONE LIVELLI")]), _vm._v(" "), _vm._c('div', {
    staticClass: "combo"
  }, [_vm._c('el-select', {
    attrs: {
      "placeholder": "Seleziona Livello",
      "size": "mini"
    },
    model: {
      value: (_vm.layer),
      callback: function($$v) {
        _vm.layer = $$v
      },
      expression: "layer"
    }
  }, _vm._l((_vm.layers), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "combo"
  }, [_vm._c('el-button', {
    staticClass: "gv-close gv-color-scheme",
    attrs: {
      "icon": "el-icon-delete",
      "type": "button",
      "size": "mini"
    },
    on: {
      "click": _vm.removeLayer
    }
  }, [_vm._c('span', {
    staticStyle: {
      "color": "#ffffff",
      "font-weight": "bold"
    }
  }, [_vm._v("Rimuovi livello")])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-928b98f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LibiossSpecie.vue
// module id = 891
// module chunks = 39